import React, { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import { Section, SectionDescription, SectionHeader, Sections, Wrapper } from './CompanyValues.elements';

interface CompanyValuesProps {}

const CompanyValuesTemplate: FC<CompanyValuesProps> = () => {
    const { t } = useTranslation();

    return (
        <ContentWrapper withPadding mobileSidePadding={20}>
            <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                {t('about.companyValues.title')}
            </TitleTemplate>
            <Wrapper>
                <Sections>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('about.companyValues.section1.label')}
                        </SectionHeader>
                        <SectionDescription>{t('about.companyValues.section1.description')}</SectionDescription>
                    </Section>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('about.companyValues.section2.label')}
                        </SectionHeader>
                        <SectionDescription>{t('about.companyValues.section2.description')}</SectionDescription>
                    </Section>
                </Sections>
                <Sections>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('about.companyValues.section4.label')}
                        </SectionHeader>
                        <SectionDescription>{t('about.companyValues.section4.description')}</SectionDescription>
                    </Section>
                    <Section isMission>
                        <SectionHeader isMission>{t('about.companyValues.section6.label')}</SectionHeader>
                        <SectionDescription>{t('about.companyValues.section6.description')}</SectionDescription>
                    </Section>
                </Sections>
            </Wrapper>
        </ContentWrapper>
    );
};
export default CompanyValuesTemplate;
